import axios from 'axios'
import loginApi from './loginApi'
import homeApi from './homeApi'
import ElementUI from "element-ui";

let instance = axios.create({
    baseURL: '/',
    // baseURL: 'http://127.0.0.1:8087/',
    // baseURL: 'http://scmapi.sporax.net/',
    timeout: 6000,
    // headers : {'Content-Type' : 'application/json;charset=UTF-8'}
})

const service = {...loginApi,...homeApi}
const Http = {};//包裹请求方法的容器

for (let key in service) {
    let api = service[key];

    Http[key] = async function (params, isFormData = false, config = {}) {
        let url = api.url;
        let newParams = {};
        if (params && isFormData) {
            newParams = new FormData();
            for (let i in params) {
                newParams.append(i, params[i])
            }
        } else {
            newParams = params;
        }
        let response = {};
        if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
            try {
                response = await instance[api.method](url, newParams, config)
            } catch (error) {
                response = error;
            }
        } else if (api.method === 'delete' || api.method === 'get') {
            config.params = newParams;
            try {
                response = await instance[api.method](url, config)
            } catch (error) {
                response = error;
            }
        }
        return response;
    }
}

instance.interceptors.request.use(config => {
    if (localStorage.getItem('Authorization')) {
        config.headers.Authorization = localStorage.getItem('Authorization');
    }
    return config;
}, () => {

})

instance.interceptors.response.use(res => {
    if(res.data.code==1003){
        ElementUI.Message({
            title: "错误",
            message: '登录失效！',
            type: "error"
          })
          setTimeout(() =>{
            window.location.href = "/#/login";
            // router.push({name: 'login',})
          },2000)
    }
    if(res.headers.authorization){
        // console.log(res.headers.authorization);
        // console.log(localStorage);
        // store.state.Authorization = res.headers.authorization;
        localStorage.setItem('Authorization',res.headers.authorization);
        // store._mutations.changeLogin({ Authorization: res.headers.authorization });
    }
    return res.data
}, () => {

})


export default Http